var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "BenefitsEgg",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-benefits-egg","viewBox":"-10 35 440 440"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <path d="M310 193.9c-28.1-48.3-63-74.8-98.7-74.8s-70.6 26.5-98.7 74.8c-23.1 39.5-37.8 88.2-37.8 124.7 0 37.8 16 72.2 41.2 96.6-14.7 5.5-23.1 12.6-23.1 19.7 0 18.5 52.9 33.6 118.4 33.6s118.4-15.1 118.4-33.6c0-7.6-8.8-14.3-23.1-19.7 25.2-24.4 41.2-58.8 41.2-96.6 0-36.5-14.7-85.2-37.8-124.7zm-98.3 249.5c-65.9 0-121.8-63-121.8-124.7 0-77.3 57.1-186.5 120.1-186.5 64.3 0 122.2 115.9 122.2 186.5 0 69.2-53.7 124.7-120.5 124.7zm5-159.6c-7.6-3.4-13-6.3-15.5-8.8-2.5-2.9-4.2-6.3-4.2-10.9 0-5 1.3-8.8 3.8-11.8 2.5-2.9 6.7-4.6 12.2-4.6s9.7 1.7 12.6 5.5c2.9 3.4 4.6 8.4 4.6 15.1h26v-.4c0-11.3-2.9-20.2-9.2-27.3-6.3-7.1-14.7-11.3-25.6-12.6v-19.7h-14.3v19.3c-11.3 1.3-20.2 5-26.9 11.3-6.7 6.3-10.1 14.7-10.1 24.8 0 10.9 3.4 19.7 10.1 25.6 6.7 5.9 16.8 11.3 30.7 16 7.1 2.9 12.2 5.5 15.1 8.4 2.9 2.9 4.2 7.1 4.2 11.8 0 5-1.7 8.8-4.6 11.8-2.9 2.9-7.6 4.2-13.4 4.2s-10.9-1.7-14.7-5c-3.8-3.4-5.9-8.8-5.9-16.4h-26l-.4.4c-.4 13 3.4 22.7 10.9 29.4s17.2 10.5 28.6 11.3v17.6H219v-17.6c11.3-1.3 20.6-5 26.9-11.3 6.7-6.3 9.7-14.7 9.7-25.2 0-10.9-3.4-19.7-10.1-26-5.3-5.3-15.3-10.7-28.8-14.9z"/>
  <path d="M415.8 309.8h-42.4c-2.5 0-4.2-1.7-4.2-4.2v-10.1c0-2.1 1.7-4.2 4.2-4.2h42.4c2.5 0 4.2 2.1 4.2 4.2v10.1c0 2.5-1.7 4.2-4.2 4.2z"/>
  <path d="M217.6 53.2v42c0 2.1-1.7 4.2-4.2 4.2h-10.1c-2.1 0-4.2-1.7-4.2-4.2v-42c0-2.1 2.1-4.2 4.2-4.2h10.1c2.5 0 4.2 1.7 4.2 4.2z"/>
  <path d="M46.6 309.8H4.2c-2.1 0-4.2-1.7-4.2-4.2v-10.1c0-2.1 1.7-4.2 4.2-4.2h42.4c2.1 0 4.2 2.1 4.2 4.2v10.1c0 2.5-2.1 4.2-4.2 4.2z"/>
  <path d="M94.5 169.5l-29.8-29.4c-1.7-1.7-1.7-4.2 0-5.9l7.1-7.1c1.7-1.7 4.2-1.7 5.9 0l29.8 29.4c1.7 1.7 1.7 4.2 0 5.9l-6.7 7.1c-1.7 1.7-4.6 1.7-6.3 0z"/>
  <path d="M323.8 169.5l29.8-29.4c1.7-1.7 1.7-4.2 0-5.9l-7.1-7.1c-1.7-1.7-4.2-1.7-5.9 0l-29.8 29.4c-1.7 1.7-1.7 4.2 0 5.9l7.1 7.1c1.7 1.7 4.2 1.7 5.9 0z"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/benefits-egg.svg